<div>
  <div class="po-field-container">
    <div class="po-field-container-title">
      <span class="po-field-title">{{ label }}</span>
    </div>
    <div class="po-field-container-content" style="flex: 1">
      @if (!disabled) {
        <div class="search-icon" (click)="submitButton.click()">
          <span class="an an-magnifying-glass po-field-icon"></span>
        </div>
      }
      @if (disabled) {
        <div class="search-icon">
          <span class="an an-magnifying-glass po-field-icon-disabled"></span>
        </div>
      }
      <form (ngSubmit)="onSubmit()" role="search">
        <input
          name="searchValue"
          type="text"
          class="po-input po-input-icon-right"
          [placeholder]="placeholder ?? ('l-search' | translate)"
          [ngModel]="value"
          (ngModelChange)="value = $event"
          [disabled]="disabled"
          autocomplete="off"
          [attr.aria-label]="placeholder ?? ('l-search' | translate)"
          [readonly]="readonly"
          (keyup.enter)="onSubmit()"
        />
        <button [hidden]="true" type="submit" #submitButton></button>
      </form>
    </div>
    @if (showAdvancedSearch) {
      <div class="advanced-search-container">
        @if (!disabled) {
          <span tabindex="0" class="advanced-search" (click)="searchAdvanced.emit()">
            {{ 'l-advanced-search' | translate }}
          </span>
        }
        @if (disabled) {
          <span tabindex="0" class="advanced-search-disabled">
            {{ 'l-advanced-search' | translate }}
          </span>
        }
      </div>
    }
  </div>
</div>
